module.exports = __webpack_public_path__ + "static/img/Poppy Seed.e621665.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Poppy Seed.jpg
// module id = lgBl
// module chunks = 0